import type { Submission } from "./backendTypes";

type AttemptStatus = "not attempted" | "correct" | "wrong" | "skipped";

type SyncStudentAttemptPayload = {
  studentId: number;
  wordEnglish: string;
  type: Submission["type"];
  status: AttemptStatus;
  attemptDate: string;
  attemptCount?: number;
  toyProgress?: unknown;
  collectible?: unknown;
};

const DEFAULT_SYNC_ENDPOINT = "/api/student-learning/attempt";

const getSyncEndpoint = (): string => {
  const configured = import.meta.env.VITE_STUDENT_LEARNING_SYNC_URL;
  return typeof configured === "string" && configured.trim()
    ? configured.trim()
    : DEFAULT_SYNC_ENDPOINT;
};

export const syncStudentAttemptToCloudSql = async (
  payload: SyncStudentAttemptPayload
): Promise<void> => {
  if (!payload.studentId || payload.studentId <= 0) return;

  try {
    const response = await fetch(getSyncEndpoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "");
      console.warn("Cloud SQL student attempt sync failed.", {
        status: response.status,
        body: text,
      });
    } else {
      console.log("Cloud SQL student attempt sync succeeded.", payload);
    }
  } catch (error) {
    console.warn("Cloud SQL student attempt sync was skipped due to an error.", error);
  }
};
